import { gql } from '@apollo/client'

export default gql(`
    mutation deleteVirtualSeasonEpisodes($input: [ID] $assetId: ID $project: String $module: String) {
        deleteVirtualSeasonEpisodes(
            input: $input
            assetId: $assetId
            project: $project
            module: $module
        )
    }`
)
